import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// sections
import { LoginForm } from '../sections/auth/login';
import MainSettingForm from 'src/sections/@dashboard/settings/MainSettingForm';
import AppUnderMaintance from 'src/sections/@dashboard/settings/AppUnderMaintance';
import AdminPaymentDetails from 'src/sections/@dashboard/settings/AdminPaymentDetails';
import ShareWithFriends from 'src/sections/@dashboard/settings/ShareWithFriends';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import api from 'src/api';
import UserBidHistory from 'src/sections/@dashboard/userInfo/UserBidHistory';
import UserPersonalInformation from 'src/sections/@dashboard/userInfo/UserPersonalInformation';
import UserWalletHistoryData from 'src/sections/@dashboard/userInfo/UserWalletHistoryData';
import UserPayMentInformation from 'src/sections/@dashboard/userInfo/UserPayMentInformation';
import { useParams } from 'react-router-dom';
import DashboardAppPage from './DashboardAppPage';
import UserJourney from 'src/sections/@dashboard/userInfo/UserJourney';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme, maxWidth }) => ({
  width: '100%',
  maxWidth: maxWidth || 800,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
  padding: 20,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function UserInfoPage() {
  const dispatch = useDispatch();
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(true);

  let { id } = useParams();

  const getAllUsers = async () => {
    dispatch(loadingStartAction());
    setLoading(true);
    const response = await api.get(`/users/${id}`);
    setData(response.data);
    setLoading(false);
    dispatch(loadingStopAction());
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  if (loading) return <h1>Loading....</h1>;
  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="lg">
          <StyledSection>
            <h3>User Personal Information</h3>
            <UserPersonalInformation data={data} />
          </StyledSection>
        </Container>
        <Container maxWidth="md">
          <StyledSection>
            <h3>Wallet</h3>
            <UserWalletHistoryData data={data} />
          </StyledSection>
          <br />
          <StyledSection>
            <h3>Payment Information</h3>
            <UserPayMentInformation data={data} getAllUsers={getAllUsers} />
          </StyledSection>
          <br />
        </Container>
      </StyledRoot>
      <br />
    
      {/* <StyledRoot>
        <StyledSection maxWidth="100%">
          <h3>Stats</h3>
          <DashboardAppPage isUserInfo url={`/dashboard-stats/user-stats/${id}`} />
        </StyledSection>
      </StyledRoot> */}

      <StyledRoot>
        <StyledSection maxWidth="100%">
          <h3>Bid Hisory</h3>
          <UserBidHistory data={data} falseLoading/>
        </StyledSection>
      </StyledRoot>

      <StyledRoot>
      
        <StyledSection maxWidth="100%">
          <h3>Hisory</h3>
          <UserJourney data={data} falseLoading/>
        </StyledSection>
      </StyledRoot>
      <br />

    </>
  );
}
